import { type FunctionComponent } from 'react';
import { BrandLinks } from '../../../../../components/product-components/brand-links/brand-links.component';
import { ManufacturerNumbers } from '../../../../../components/product-components/manufacturer-numbers/manufacturer-numbers.component';
import { ManufacturerResources } from '../../../../../components/product-components/manufacturer-resource/manufacturer-resource.component';
import { ProductAttributes } from '../../../../../components/product-components/product-attributes/product-attributes.component';
import { ProductDescription } from '../../../../../components/product-components/product-description/product-description.component';
import { RelatedCategoriesPanel } from '../../../../../components/product-components/related-categories-panel/related-categories-panel.component';
import { FEATURE_FLAGS } from '../../../../../constants/general';
import { useFeature } from '../../../../../hooks/features/features.hooks';
import { type PdpProductFamily } from '../../../../../types/product.types';

type ProductOverviewProps = {
	product: PdpProductFamily;
};

export const ProductOverview: FunctionComponent<ProductOverviewProps> = ({ product }) => {
	const isManufacturerNumbersSectionActive = useFeature(FEATURE_FLAGS.MANUFACTURER_NUMBERS_SECTION);

	return (
		<div className="flex flex-wrap f5" data-testid="product-overview-body">
			<div className="w-100 w-two-thirds-ns pr3">
				{product.description && <ProductDescription description={product.description} />}
				<div className="mt3">
					<BrandLinks brand={product.brandInfo} collection={product.collection} />
				</div>
				{isManufacturerNumbersSectionActive && (
					<>
						<div className="bb b--theme-grey-light" />
						<ManufacturerNumbers brandName={product.brandInfo.name} variants={product.variants} />
					</>
				)}
			</div>
			<div className="w-100 w-third-ns">
				{product.resources && product.resources.length > 0 && <ManufacturerResources resources={product.resources} />}
				{product.attributeGroups?.map((attributeGroup, index) => (
					<ProductAttributes headingValue="h3" key={index} attributeGroup={attributeGroup} />
				))}
				<div className="mt3">
					<RelatedCategoriesPanel brand={product.brandInfo} categories={product.relatedCategories} />
				</div>
			</div>
		</div>
	);
};
